<template>
  <div class="container-fluid py-4 px-4">
    <section id="loader" v-if="isLoading">
      <base-component-loader />
    </section>

    <section v-else id="content">
      <div class="row no-gutters text-left">
        <div class="col-12 col-md-auto pr-5">
          <h4 class="font-weight-bold">{{ vesselDetails.name }}</h4>
          <p v-if="vesselDetails.type">{{ vesselDetails.type.toUpperCase() }}</p>
        </div>
        <div class="col-12 col-md-auto">
          <div class="btn-group" role="group" aria-label="Basic example">
            <section v-if="!isEditable">
              <base-secondary-btn @click.native="goBack">
                <font-awesome-icon icon="undo" />
                <span class="ml-1">Go Back</span>
              </base-secondary-btn>
              <base-warning-btn v-if="!isLoading" @click.native="edit" class="ml-2">
                <font-awesome-icon icon="edit" />
                <span class="ml-1">Edit</span>
              </base-warning-btn>
            </section>

            <section v-if="isEditable">
              <base-success-btn @click.native="save">
                <font-awesome-icon icon="save" />
                <span class="ml-1">Save</span>
              </base-success-btn>
              <base-danger-btn @click.native="cancel" class="ml-2">
                <font-awesome-icon icon="ban" />
                <span class="ml-1">Cancel</span>
              </base-danger-btn>
            </section>
          </div>
        </div>
      </div>

      <div class="row no-gutters text-left">
        <div class="col-12">
          <base-table :loading="isLoading" :loader-colspan="2" :max-height="480">
            <template slot="table-header">
              <tr>
                <th>Ranks</th>
                <th>Action</th>
              </tr>
            </template>

            <template slot="table-body">
              <tr v-for="(rank,index) in objRankKeys" :key="rank.id">
                <td class="text-left align-middle pl-4">{{ rank.name.toUpperCase() }}</td>
                <td class="text-center align-middle">
                  <input type="checkbox" :id="`rank-check-box`+index" name="rankCheckBox"
                         :value="rank.id"
                         @click="clickCheckBox(`rank-check-box`+index,vesselTonRanks.find(((value, index) => value ==rank.id)))"
                         :disabled="!isEditable"
                         :checked="vesselTonRanks.find(((value, index) => value ==rank.id))" />
                </td>
              </tr>
            </template>
          </base-table>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import {AppMixins} from '../../../mixins/app.mixins';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'view',

  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      vesselId: parseInt(this.$route.params.vesselId,10),
      isEditable: false,
      vesselTonRanks_state: [],
      toBeDelRankIds: [],
    };
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'getVesselTonRanks',
          'updateVesselTonRanks',
          'set_vessel_ton_ranks',
          'reset_vessel_details',
          'reset_vessel_ton_ranks',
        ],
    ),

    edit() {
      this.isEditable = !this.isEditable;
      // console.log('This is the following ,');
    },

    async save() {
      let qMsgHtml = '<span>Are you sure you want to save the changes you made.</span>';
      if (await this.questionFormAlert(`${qMsgHtml}`, 'Update Vessel TON Ranks')) {
        const payload = {
          vesselId: this.vesselId,
          vesselTonRanks: this.vesselTonRanks,
          toBeDelRankIds: this.toBeDelRankIds,
        };
        this.updateVesselTonRanks(payload).then((r) => {
          if (r) {
            this.successFormAlert('Update successfully', 'Vessel TON Ranks');
            this.isEditable = false;
            this.toBeDelRankIds = [];
          }
        });
      }
    },

    cancel() {
      this.isEditable = !this.isEditable;
      this.toBeDelRankIds = [];
      this.set_vessel_ton_ranks(this.originalState(`vessel`,'vesselTonRanks'))
    },

    clickCheckBox(__tagElement, __objVal) {
      let checkBoxEl = `#` + __tagElement;
      let checkBox = $(checkBoxEl).is(`:checked`);
      let checkBoxVal = $(`${checkBoxEl}:checked`).val();
      let unCheckBoxVal = $(`${checkBoxEl}:not(:checked)`).val();

      if (checkBox) {
        let pCheckBoxVal = parseInt(checkBoxVal, 10);
        this.vesselTonRanks.push(pCheckBoxVal);

        let index = this.toBeDelRankIds.indexOf(pCheckBoxVal);
        if (index > -1) {
          this.toBeDelRankIds.splice(index, 1);
        }

      } else {
        let pUnCheckBoxVal = parseInt(unCheckBoxVal, 10);
        this.toBeDelRankIds.push(pUnCheckBoxVal);
        let index = this.vesselTonRanks.indexOf(pUnCheckBoxVal);
        if (index > -1) {
          this.vesselTonRanks.splice(index, 1);
        }
      }
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'vessel',
          'isLoading',
          'objRankKeys',
          'vesselDetails',
          'vesselTonRanks',
        ],
    ),
  },

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
    this.vesselTonRanks_state = this.vesselTonRanks

    if (!this.vesselDetails) {
      this.getVesselTonRanks(this.vesselId);
    }

  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
    this.reset_vessel_ton_ranks()
    this.reset_vessel_details()
  },
};
</script>

<style scoped>
input[type="checkbox"] {
  transform: scale(2) !important;
}
</style>
